<template lang="pug">
#modal-desativar-monitoramento
    el-dialog(
        :title='$t("mensagens.monitoramentoAgricola.desativarMonitoramento")',
        width='500px',
        :visible.sync='mostrar',
        :before-close='fecharModal'
    )
        h3 Deseja realmente cancelar o monitoramento {{ areasMonitoradas.length > 1 ? 'dos territórios' : 'do território' }}:
        ul
            li(
                v-for='areaMonitorada in areasMonitoradas',
                :key='areaMonitorada.id'
            ) {{ areaMonitorada.territorio.nome }}

        footer.espacamento(slot='footer')
            el-button(type='default', size='mini', @click='fecharModal') Voltar
            el-button(
                type='primary',
                size='mini',
                @click='desativarMonitoramentos',
                :loading='desativando'
            ) Desativar
</template>

<script>
import areasMonitoradasService from '@/services/AreasMonitoradasService';

export default {
    name: 'ModalDesativarMonitoramento',

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        areasMonitoradas: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            desativando: false
        };
    },

    methods: {
        async desativarMonitoramentos() {
            this.desativando = true;

            try {
                const idsAreaMonitorada = [];
                this.areasMonitoradas.forEach(({ id }) =>
                    idsAreaMonitorada.push(id)
                );
                await areasMonitoradasService.desativarMonitoramentos({
                    idsAreaMonitorada
                });

                const message =
                    this.areasMonitoradas.length > 1
                        ? 'Áreas monitoradas desativadas com sucesso.'
                        : 'Área monitorada desativada com sucesso.';

                this.$notify.success({ message });
                this.$emit('atualizarTabela');
                this.fecharModal();
            } catch (error) {
                const message =
                    this.areasMonitoradas.length > 1
                        ? 'Não foi possível desativar as áreas monitoradas.'
                        : 'Não foi possível desativar a área monitorada.';

                this.$notify.error({ message });
            } finally {
                this.desativando = false;
            }
        },

        fecharModal() {
            this.$emit('fechar');
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-diagnostico__btn-confimar {
    display: flex;
    justify-content: center;
}

.espacamento {
    display: flex;
    justify-content: space-between;
}

.modal-diagnostico__btn-exportacao {
    display: flex;
    justify-content: space-between;
}
</style>
